import { buildApiUrl } from '../../config/env';
import { readResponseJson } from './http';

export interface DashboardSummary {
  ledger: {
    totalCredit: number;
    totalDebit: number;
    totalBalance: number;
  };
  work: {
    contracts: number;
    supplies: number;
    products: number;
    quotationsSent: number;
    quotationsAccepted: number;
    quotationsClosed: number;
  };
  network: {
    connections: number;
    pendingSent: number;
    pendingReceived: number;
    connectionTypeBreakdown: {
      mentor: number;
      client: number;
      supplier: number;
      others: number;
    };
  };
  clubs: Array<{
    id: string;
    name: string;
    category: string;
    coverPhoto: string | null;
    memberCount: number;
    stats: {
      meetupsAccepted: number;
      bIntrosSentAccepted: number;
      bIntrosReceivedAccepted: number;
    };
  }>;
  notifications: Array<{
    id: string;
    type: string;
    title: string;
    message: string;
    read: boolean;
    createdAt: string;
  }>;
}

export const getDashboardSummary = async (token: string): Promise<DashboardSummary> => {
  const response = await fetch(buildApiUrl('/api/dashboard/summary'), {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await readResponseJson(response);

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to fetch dashboard summary');
  }

  return data.data;
};
